import React, { Component } from "react";
import { FiX, FiMenu } from "react-icons/fi";
import LanguageSwitcher from "../LanguageSwitcher/LanguageSwitcher";
import { withTranslation } from "react-i18next";

class Header extends Component {
  constructor(props) {
    super(props);
    this.menuTrigger = this.menuTrigger.bind(this);
    this.CLoseMenuTrigger = this.CLoseMenuTrigger.bind(this);
  }

  menuTrigger() {
    document.querySelector(".header-wrapper").classList.toggle("menu-open");
  }
  CLoseMenuTrigger() {
    document.querySelector(".header-wrapper").classList.remove("menu-open");
  }
  render() {
    const { i18n } = this.props;
    // Check the current language
    const isEnglish = i18n.language === "en";

    window.addEventListener("scroll", function () {
      var value = window.scrollY;
      if (value > 50) {
        document.querySelector(".header--fixed").classList.add("sticky");
      } else {
        document.querySelector(".header--fixed").classList.remove("sticky");
      }
    });

    var elements = document.querySelectorAll(".has-droupdown > a");
    for (var i in elements) {
      if (elements.hasOwnProperty(i)) {
        elements[i].onclick = function () {
          this.parentElement
            .querySelector(".submenu")
            .classList.toggle("active");
          this.classList.toggle("open");
        };
      }
    }

    return (
      <header className="header-area formobile-menu header--fixed default-color">
        <div className="header-wrapper" id="header-wrapper">
          <div className="header-left">
            <div className="logo">
              <a href="/home">
                <img
                  className="logo-1"
                  src="/assets/images/logo/cus-lightv2.png"
                  alt="Logo Images"
                />
                <img
                  className="logo-2"
                  src="/assets/images/logo/cus-logov2.png"
                  alt="Logo Images"
                />
              </a>
            </div>
          </div>
          <div className="header-right">
            <nav className="mainmenunav d-lg-block">
              <ul className="mainmenu">
                <li className="has-droupdown">
                  <a href="#">{isEnglish ? "About" : "À propos"}</a>
                  <ul className="submenu">
                    <li>
                      <a href="/about">{isEnglish ? "About" : "À propos"}</a>
                    </li>
                    <li>
                      <a href="/team">{isEnglish ? "Team" : "Équipe"}</a>
                    </li>
                    <li>
                      <a href="/contact">Contact</a>
                    </li>
                  </ul>
                </li>

                <li>
                  <a href="/projects">
                    {isEnglish ? "Research Project" : "Projet de recherche"}
                  </a>
                </li>
                <li>
                  <a href="/news">
                    {isEnglish ? "Collaboration et partenariatss" : "Collaboration and Partnership	"}
                  </a>
                </li>
                <li>
                  <a href="/educations">
                    {isEnglish
                      ? "Education & Outreach"
                      : "Éducation et diffusion"}
                  </a>
                </li>
                <li>
                  <a href="/publications">Publications</a>
                </li>

                <li>
                  <LanguageSwitcher />
                </li>
              </ul>
            </nav>
            <div className="humberger-menu d-block d-lg-none pl--20 pl_sm--10">
              <span
                onClick={this.menuTrigger}
                className="menutrigger text-white"
              >
                <FiMenu />
              </span>
            </div>
            <div className="close-menu d-block d-lg-none">
              <span onClick={this.CLoseMenuTrigger} className="closeTrigger">
                <FiX />
              </span>
            </div>
          </div>
        </div>
      </header>
    );
  }
}
export default withTranslation()(Header);
